import liff from "@line/liff";

interface Profile {
  userId: string;
  displayName: string;
  pictureUrl?: string;
}

let cached: Profile | null = null;
let initialized = false;

const LIFF_ID = import.meta.env.VITE_LIFF_ID as string | undefined;

export async function initLiff(): Promise<void> {
  if (initialized) return;

  if (!LIFF_ID) {
    console.warn("[liff] VITE_LIFF_ID not set — running in dev/standalone mode");
    initialized = true;
    return;
  }

  await liff.init({ liffId: LIFF_ID });

  if (!liff.isLoggedIn()) {
    liff.login();
    return; // page will redirect
  }

  try {
    const p = await liff.getProfile();
    cached = { userId: p.userId, displayName: p.displayName, pictureUrl: p.pictureUrl };
  } catch (err) {
    console.warn("[liff] getProfile failed:", err);
  }

  initialized = true;
}

export function getProfile(): Profile | null {
  return cached;
}

export function isInClient(): boolean {
  try {
    return Boolean(LIFF_ID) && liff.isInClient();
  } catch {
    return false;
  }
}

export async function sendMessages(messages: { type: "text"; text: string }[]): Promise<void> {
  if (!LIFF_ID) {
    // Dev mode: just log
    console.log("[liff] sendMessages (dev mode):", messages);
    return;
  }
  if (!liff.isInClient()) {
    throw new Error("請從 LINE 內開啟才能送出訊息");
  }
  await liff.sendMessages(messages);
}

export async function closeWindow(): Promise<void> {
  if (LIFF_ID && liff.isInClient()) liff.closeWindow();
}
